var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { H2 } from "@irati/ui/src/Headings";
import { DosisBold } from "@irati/ui/src/global/fonts";
export var Title = styled(H2)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 30px 30px;\n"], ["\n  margin: 0 30px 30px;\n"])));
export var Text = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 21px;\n  margin-bottom: 45px;\n  line-height: 27px;\n  ", "\n"], ["\n  font-size: 21px;\n  margin-bottom: 45px;\n  line-height: 27px;\n  ", "\n"])), DosisBold);
export var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  text-align: center;\n"], ["\n  ", "\n  text-align: center;\n"])), function (_a) {
    var withMarginTop = _a.withMarginTop;
    return withMarginTop && "margin-top: 25vh;";
});
export var Img = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 181px;\n  margin-bottom: 30px;\n"], ["\n  width: 181px;\n  margin-bottom: 30px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
